import Modal from 'react-modal';
import { Button } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { Header, Container, Content } from './style';

interface IModalSignupProps {
  isOpen: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const ModalSignUp = ({ isOpen, onConfirm, onClose }: IModalSignupProps) => {
  const setZIndex = {
    overlay: {
      zIndex: 1000,
    },
  };

  return (
    <Modal
      style={setZIndex}
      isOpen={isOpen}
      overlayClassName="react-modal-overlay"
      className="react-add-modal-content">
      <Container>
        <Header>
          <div className="subHeader">
            <h1>Crie uma conta!</h1>
          </div>
          <div className="close-div">
            <button type="button" onClick={onClose}>
              <CloseIcon fontSize="small" />
            </button>
          </div>
        </Header>
        <Content>
          <p>
            <InfoOutlinedIcon />
            Se cadastre para usar nossos serviços
          </p>
          <Button onClick={onConfirm}>Cadastrar</Button>
        </Content>
      </Container>
    </Modal>
  );
};
